import {SEventContainer} from "@/Master/SEventContainer";
import {IPresenter} from "@/Master/IPresenter";
import UtilBrowser from "@/Master/UtilBrowser";
import AdjustMgr from "@/Fwk/AdjustMgr";

export enum SPlayerEvent {
    OnSecondTick,
    OnUpdate,
    RegisterSuccessful,//(userType:UserLoginType)=>void
    LoginSuccessful,//(userType:UserLoginType)=>void
    LoginFailed,//(userType:UserLoginType)=>void
}

export enum UserLoginType {
    Normal,
    Visitor,
}

export default class SPlayer {
    static curTime: number;
    static deltaTime = 0;
    static secondTick = 0;
    static isEnterMainScene = false;
    private static _isInit = false;
    static listener = new SEventContainer();
    static _listenerList: SEventContainer[] = [];
    private static _presenterList: IPresenter[] = [];
    private static _objectDispose:any;

    static checkInit() {
        if (SPlayer._isInit) {
            return;
        }
        SPlayer._isInit = true;
        SPlayer.init();
    }

    //所有数据相关的初始化放这里
    private static init() {
        //初始化Adjust
        AdjustMgr.Init();

        //初始化浏览器信息
        UtilBrowser.Init();

        this._listenerList.push(this.listener);
    }

    static GObjectDispose() {
        // @ts-ignore
        let obj:GObject = this;
        if (obj.isDisposed){
            return;
        }
        obj.displayObject.event("onDispose");
        SPlayer._objectDispose.call(obj);
    }

    static addPresenter(presenter: IPresenter) {
        if (this._presenterList.indexOf(presenter) == -1) {
            this._presenterList.push(presenter);
        }
        let listener = presenter.listener;
        if (listener && this._listenerList.indexOf(listener) == -1) {
            this._listenerList.push(listener);
        }
    }

    static on(objKey: any, eventType: SPlayerEvent, callback: Function, target?: any) {
        this.listener.on(objKey, eventType, callback, target);
    }

    static off(objKey: any) {
        this.listener.off(objKey);
    }

    static offAll(objKey: any) {
        for (let listener of this._listenerList) {
            listener.off(objKey);
        }
    }

    static invoke(eventType: SPlayerEvent, ...args: any[]) {
        this.listener.invoke(eventType, ...args);
    }

}
    